import Model from '@/models/Model'

export default class PosCustomerReceivablePayment extends Model {
  resource() {
    return 'pos_customer_receivable_payment'
  }
}